import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { SocialProofBar } from '../components/SocialProofBar';
const ProblemSection = lazy(() => import('../components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SolutionSection = lazy(() => import('../components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const WhatYouGet = lazy(() => import('../components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const UrgencySection = lazy(() => import('../components/UrgencySection').then(m => ({
  default: m.UrgencySection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const EliteSection = lazy(() => import('../components/EliteSection').then(m => ({
  default: m.EliteSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTA = lazy(() => import('../components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-white" data-id="element-270">
      <div data-id="element-271">
        <HeroSection data-id="element-272" />
        <SocialProofBar data-id="element-273" />

        <Suspense fallback={null} data-id="element-274">
          <ProblemSection data-id="element-275" />
          <SolutionSection data-id="element-276" />
          <WhatYouGet data-id="element-277" />
          <BonusSection data-id="element-278" />
          <UrgencySection data-id="element-279" />
          <PricingSection data-id="element-280" />
        </Suspense>

        <Suspense fallback={null} data-id="element-281">
          <EliteSection data-id="element-282" />
          <TestimonialsSection data-id="element-283" />
          <GuaranteeSection data-id="element-284" />
          <FAQSection data-id="element-285" />
          <FinalCTA data-id="element-286" />
          <Footer data-id="element-287" />
          <SocialProofPopup data-id="element-288" />
        </Suspense>
      </div>
    </main>;
}